module.exports = __webpack_public_path__ + "static/images/styles/images/chess-pattern-white.666be6b1.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/chess-pattern-white.png
// module id = 3616
// module chunks = 11